<template>
  <div class="upload-deal-highlights-container">
    <input 
      type="file" 
      accept=".pdf"
      ref="file"
      style="display: none"
      @change="uploadPdf" />

    <v-btn
      hide-details
      :title="buttonTitle"
      :disabled="uploading"
      :loading="uploading"
      @click="$refs.file.click()"
    >
      Upload Deal Highlights
    </v-btn>

    <v-btn
      v-if="(lastUploaded && lastUploaded !== 'Never') || currentUploadTime"
      hide-details
      class="ml-2 mr-2"
      :disabled="uploading"
      @click="downloadPdf"
    >
      Download Deal Highlights
    </v-btn>
    
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie';
import dateformat from 'dateformat'

import appUrls from '../../helpers/environment'

export default {
  name: 'UploadDealHighlights',

  props: {
    listingId: String,
    lastUploaded: String,
  },

  data: () => ({
    uploading: false,
    currentUploadTime: '',
  }),

  computed: {
    buttonTitle () {
      const time = this.currentUploadTime || this.lastUploaded
      return `Last Uploaded: ${time ? dateformat(time) : 'Never'}`
    },
  },


  methods: {
    async uploadPdf (event) {
      this.uploading = true

      try {
        const formData = new FormData()
        formData.append('file', event.target.files[0])

        const data = await axios.post(
          `${appUrls.api}/api/admin/listing-deal-highlights/${this.listingId}`,
          formData,
          {
            headers: {
              authentication: Cookie.get('token'),
              'Content-Type': 'multipart/form-data',
            },
          },
        )

        this.currentUploadTime = dateformat(new Date())

        this.$feedback.success( 'Uploaded the PDF and saved it to S3' )
      } catch (err) {
        this.$feedback.error( `There was a problem uploading the PDF. ${err.message}` )

        console.error('Failed to upload PDF', err)
      }

      event.target.value = ''
      this.uploading = false
    },

    downloadPdf () {
      window.open(`${appUrls.api}/api/listing-deal-highlights/${this.listingId}`)
    }
  },
}
</script>

<style scoped>
.upload-deal-highlights-container {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/UploadDealHighlightsOfListing.vue